import { SubtypesTable } from './components/SubtypesTable'
import { SubtypesTableProvider } from './SubtypesTableContext'

const Subtypes: React.FC = () => (
  <SubtypesTableProvider>
    <SubtypesTable />
  </SubtypesTableProvider>
)

export default Subtypes
